import { FieldRendererProps } from "../fieldRenderersEditors";
import StringFieldRenderer, { StringFieldRendererProps } from "./StringFieldRenderer";

export class NumberFieldRenderer extends StringFieldRenderer<StringFieldRendererProps> {

}

export default NumberFieldRenderer;